import { useEffect, useRef, useCallback } from 'react';

interface Partner {
  name: string;
  abbr?: string;
  logo?: string;
  logoScale?: number;
}

const partners: Partner[] = [
  { name: 'LBC Innovative Transformation', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/c3f7f55f2e9bd2d328f37a5a77842a8d.png' },
  { name: 'Brighten', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/2983c2fe6a9524cd3ab0072f70256890.png' },
  { name: 'INAPEM', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/c2c517242068e2c0e39d2ce420ad1238.png' },
  { name: 'Ministério do Planeamento de Angola', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/712a0b4efb212c73796bce86d7789957.png' },
  { name: 'WHED', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/04d2010fa3f1dd8038efa73ac9e7e88a.png', logoScale: 1.6 },
  { name: 'Meios', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/8876c708ef6f02f782a9167f6c16a7b6.png' },
  { name: 'BSO Consulting', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/a922fdc7732fc1d852a28159c39d92b0.png' },
  { name: 'Câmara de Comércio e Indústria Portuguesa', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/dda3563b073552a9822fa7e45c74ab5e.png' },
  { name: 'Crescer Angola', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/f2fd603376091d1002d65b654b525d0d.png' },
  { name: 'Farol Corretora de Seguros 2', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/f77520868d6f01dbdacc6685791c5aa5.png' },
  { name: 'Adriana Dias Consultoria & Projetos', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/936f4c9a887084d924c2439721b6d340.png' },
  { name: 'DWD Prestação de Serviços', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/36fc55bf38c26455b46f91524896746a.png' },
  { name: 'E. Chabango Rent-A-Car', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/0f5b8ab2cddcddd359f520566f0d2b54.png' },
  { name: 'FIXIIND', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/4d644d1eb7d8b9ac3097c87cdf12f631.png' },
  { name: 'Kudima', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/479c2eff088488cea18a7f7b2dcbe668.png' },
  { name: 'Manilundu', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/85a0bef1ddcc4631284ec3e0bc14f918.png' },
  { name: 'Nambundo Estúdio', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/fa8428185068fbf80d90e4497cc54f3a.png' },
  { name: 'Ngassakidila Lights 2', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/35d7c98196d038b396406d91245d182b.png' },
  { name: 'Paraqus', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/d05b7520683d99c6c564c55f6524dec0.png' },
  { name: 'PS Lubittus', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/019f168e6e319be417c2232044879bcc.png' },
  { name: 'Twalendwa (su), lda 2', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/8b56a2e9cbfaa912c474225f769ba785.png' },
  { name: 'Damer Gráficas, S.A.', logo: 'https://static.readdy.ai/image/fb4c53576b1299f0fd427ad804580ce2/fc22c08beea2edad00e93d1e21940025.png' },
];


export default function PartnersSection() {
  const trackRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const animationIdRef = useRef<number>(0);
  const positionRef = useRef(0);
  const isDraggingRef = useRef(false);
  const dragStartXRef = useRef(0);
  const dragStartPosRef = useRef(0);
  const isAutoPlayingRef = useRef(true);
  const speed = 0.5;

  const step = useCallback(() => {
    const track = trackRef.current;
    if (!track || isDraggingRef.current) return;
    positionRef.current -= speed;
    const halfWidth = track.scrollWidth / 2;
    if (Math.abs(positionRef.current) >= halfWidth) {
      positionRef.current = 0;
    }
    track.style.transform = `translateX(${positionRef.current}px)`;
    animationIdRef.current = requestAnimationFrame(step);
  }, []);

  const startAutoPlay = useCallback(() => {
    if (!isAutoPlayingRef.current) return;
    cancelAnimationFrame(animationIdRef.current);
    animationIdRef.current = requestAnimationFrame(step);
  }, [step]);

  const stopAutoPlay = useCallback(() => {
    cancelAnimationFrame(animationIdRef.current);
  }, []);

  useEffect(() => {
    isAutoPlayingRef.current = true;
    startAutoPlay();
    return () => stopAutoPlay();
  }, [startAutoPlay, stopAutoPlay]);

  /* ── Drag handlers ── */
  const onDragStart = useCallback((clientX: number) => {
    isDraggingRef.current = true;
    dragStartXRef.current = clientX;
    dragStartPosRef.current = positionRef.current;
    stopAutoPlay();
    if (trackRef.current) trackRef.current.style.transition = 'none';
    if (containerRef.current) containerRef.current.style.cursor = 'grabbing';
  }, [stopAutoPlay]);

  const onDragMove = useCallback((clientX: number) => {
    if (!isDraggingRef.current || !trackRef.current) return;
    const delta = clientX - dragStartXRef.current;
    const track = trackRef.current;
    const halfWidth = track.scrollWidth / 2;
    let newPos = dragStartPosRef.current + delta;
    if (newPos > 0) newPos = newPos - halfWidth;
    if (Math.abs(newPos) >= halfWidth) newPos = newPos + halfWidth;
    positionRef.current = newPos;
    track.style.transform = `translateX(${newPos}px)`;
  }, []);

  const onDragEnd = useCallback(() => {
    if (!isDraggingRef.current) return;
    isDraggingRef.current = false;
    if (trackRef.current) trackRef.current.style.transition = '';
    if (containerRef.current) containerRef.current.style.cursor = 'grab';
    startAutoPlay();
  }, [startAutoPlay]);

  // Mouse events
  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    onDragStart(e.clientX);
  }, [onDragStart]);

  const handleMouseMove = useCallback((e: React.MouseEvent) => {
    onDragMove(e.clientX);
  }, [onDragMove]);

  const handleMouseUp = useCallback(() => onDragEnd(), [onDragEnd]);
  const handleMouseLeave = useCallback(() => onDragEnd(), [onDragEnd]);

  // Touch events
  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    onDragStart(e.touches[0].clientX);
  }, [onDragStart]);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    onDragMove(e.touches[0].clientX);
  }, [onDragMove]);

  const handleTouchEnd = useCallback(() => onDragEnd(), [onDragEnd]);

  const doubled = [...partners, ...partners];

  return (
    <section className="py-16 bg-[#011820] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-10 text-center">
        <p className="text-white/30 text-xs font-semibold uppercase tracking-[0.2em] mb-2">
          Parceiros & Clientes
        </p>
        <h2 className="text-white text-2xl md:text-3xl font-bold">
          Empresas que confiam na <span className="text-[#026A86]">MoveMind</span>
        </h2>
      </div>

      <div
        ref={containerRef}
        className="overflow-hidden relative select-none"
        style={{ cursor: 'grab' }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="absolute left-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-r from-[#011820] to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 z-10 bg-gradient-to-l from-[#011820] to-transparent pointer-events-none" />

        <div ref={trackRef} className="flex gap-3 will-change-transform" style={{ width: 'max-content' }}>
          {doubled.map((partner, i) => (
            <div
              key={`${partner.name}-${i}`}
              className="group flex-shrink-0 w-40 h-[68px] flex items-center justify-center rounded-lg border border-white/8 hover:border-[#026A86]/60 hover:shadow-[0_0_16px_rgba(2,106,134,0.25)] transition-all duration-300 cursor-pointer px-3 overflow-hidden"
              style={{ background: partner.logo ? 'rgba(255,255,255,0.96)' : 'rgba(255,255,255,0.03)' }}
            >
              {partner.logo ? (
                <div className="transition-transform duration-300 group-hover:scale-110 flex items-center justify-center">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-h-10 max-w-full w-auto object-contain"
                    style={partner.logoScale ? { transform: `scale(${partner.logoScale})` } : undefined}
                  />
                </div>
              ) : (
                <div className="flex flex-col items-center gap-1">
                  <div className="w-7 h-7 flex items-center justify-center rounded-md bg-[#026A86]/20">
                    <span className="text-[#026A86] text-[10px] font-black tracking-wider">{partner.abbr}</span>
                  </div>
                  <span className="text-white/50 text-[10px] font-medium text-center leading-tight">{partner.name}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
